var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path2, _rect12, _rect13, _rect14, _path3, _rect15, _rect16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgİconCorporate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.684,2.789v12.791h2.132v-2.606c0-.131.106-.237.237-.237h1.895c.131,0,.237.106.237.237v2.606h2.132V1.367c0-.524-.424-.948-.948-.948h-4.738c-.524,0-.948.424-.948.948v1.421ZM8.474,2.552c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948ZM8.474,4.921c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948ZM8.474,7.289c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948ZM8.474,9.658c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948ZM6.105,2.552c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948ZM6.105,4.921c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948ZM6.105,7.289c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948ZM6.105,9.658c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948Z",
    fill: "#fdc520"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.579,
    y: 7.526,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.579,
    y: 9.895,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.289,
    y: 13.211,
    width: 1.421,
    height: 2.369,
    fill: "#fdc520"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.895,
    y: 12.264,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 6.579,
    y: 2.789,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6.579,
    y: 5.157,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8.948,
    y: 5.157,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 8.948,
    y: 2.789,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8.948,
    y: 7.526,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 8.948,
    y: 9.895,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 1.895,
    y: 9.895,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.79,2.789H.948c-.524,0-.948.424-.948.948v10.896c0,.524.424.948.948.948h2.843V2.789ZM2.843,12.974c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948ZM2.843,10.606c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948ZM2.843,8.237c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948ZM2.606,6.105h-.948c-.131,0-.237-.106-.237-.237v-.948c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948c0,.131-.106.237-.237.237Z",
    fill: "#fdc520"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 13.631,
    y: 12.264,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 13.631,
    y: 9.895,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 13.631,
    y: 7.526,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.052,5.157h-2.843v10.423h2.843c.524,0,.948-.424.948-.948V6.105c0-.524-.424-.948-.948-.948ZM14.579,12.974c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948ZM14.579,10.606c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948ZM14.579,8.237c0,.131-.106.237-.237.237h-.948c-.131,0-.237-.106-.237-.237v-.948c0-.131.106-.237.237-.237h.948c.131,0,.237.106.237.237v.948Z",
    fill: "#fdc520"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 1.895,
    y: 7.526,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 1.895,
    y: 5.157,
    width: 0.474,
    height: 0.474,
    fill: "#fdc520"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgİconCorporate);
export default __webpack_public_path__ + "static/media/icon_corporate.815f53336590fd296ae45f55c38782b9.svg";
export { ForwardRef as ReactComponent };